export const GET_INTERESTS_REQUEST = "GET_INTERESTS_REQUEST";
export const GET_INTERESTS_SUCCESS = "GET_INTERESTS_SUCCESS";
export const GET_INTERESTS_FAILURE = "GET_INTERESTS_FAILURE";

export const GET_HEAR_ABOUT_US_REQUEST = "GET_HEAR_ABOUT_US_REQUEST";
export const GET_HEAR_ABOUT_US_SUCCESS = "GET_HEAR_ABOUT_US_SUCCESS";
export const GET_HEAR_ABOUT_US_FAILURE = "GET_HEAR_ABOUT_US_FAILURE";

export const GET_COURSE_TYPE_REQUEST = "GET_COURSE_REQUEST";
export const GET_COURSE_TYPE_SUCCESS = "GET_COURSE_SUCCESS";
export const GET_COURSE_TYPE_FAILURE = "GET_COURSE_FAILURE";
